import type { ComponentProps } from 'react';

import {
  Tooltip as OriginalTooltip,
  TooltipContent,
  TooltipTrigger,
} from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

export const Tooltip = ({
  asChild,
  children,
  description,
  disabled,
  className,
  ...contentProps
}: ComponentProps<typeof TooltipContent> & {
  children: React.ReactNode;
  description: React.ReactNode;
  className?: string;
  disabled?: boolean;
}) => {
  const isDisabled = !description || disabled;

  return (
    <OriginalTooltip>
      <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>
      {!isDisabled && (
        <TooltipContent
          {...contentProps}
          className={cn('z-tooltip', className)}
        >
          {description}
        </TooltipContent>
      )}
    </OriginalTooltip>
  );
};
